import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { Buyer } from '@ps/core-models';

import {
  AuthCredentials,
  ForgotPasswordCredentials,
  ResetPasswordCredentials,
  SetPasswordCredentials,
  PersistAuthSettings,
} from '../models/auth.model';
import { ImpersonatedBuyer } from '../models/impersonation.model';
import { AuthSessionActions } from './auth-session/auth-session.actions';
import { AuthPasswordActions } from './auth-password/auth-password.actions';
import { AuthSsoActions } from './auth-sso/auth-sso.actions';
import { ImpersonationActions } from './impersonation/impersonation.actions';

@Injectable({ providedIn: 'root' })
export class AuthActionsFacade {
  private readonly _store = inject(Store);

  public login(credentials: AuthCredentials): void {
    this._store.dispatch(AuthSessionActions.login(credentials));
  }

  public forgotPassword(credentials: ForgotPasswordCredentials): void {
    this._store.dispatch(AuthPasswordActions.forgotPassword(credentials));
  }

  public resetPassword(credentials: ResetPasswordCredentials): void {
    this._store.dispatch(AuthPasswordActions.resetPassword(credentials));
  }

  public setPassword(credentials: SetPasswordCredentials): void {
    this._store.dispatch(AuthPasswordActions.setPassword(credentials));
  }

  public logout(): void {
    this._store.dispatch(AuthSessionActions.logout());
  }

  public checkSsoEmail(email: string): void {
    this._store.dispatch(AuthSsoActions.checkEmail({ email }));
  }

  public exchangeSsoCode(code: string): void {
    this._store.dispatch(AuthSsoActions.exchangeCode({ code }));
  }

  public rehydrate(payload: PersistAuthSettings): void {
    this._store.dispatch(AuthSessionActions.rehydrate(payload));
  }

  public clearAuth(): void {
    this._store.dispatch(AuthSessionActions.clearState());
  }

  // Impersonation actions

  public connect(payload: Buyer): void {
    this._store.dispatch(ImpersonationActions.connect(payload));
  }

  public disconnect(): void {
    this._store.dispatch(ImpersonationActions.disconnect());
  }

  public switchBuyer(payload: Buyer): void {
    this._store.dispatch(ImpersonationActions.switchBuyer(payload));
  }

  public rehydrateImpersonation(impersonatedBuyer: ImpersonatedBuyer): void {
    this._store.dispatch(
      ImpersonationActions.rehydrate({ buyerCompany: impersonatedBuyer }),
    );
  }
}
